import * as React from "react";
import { ContextMenu, MenuItem, } from "react-contextmenu";
import { ThunkDispatch } from "redux-thunk";
import { batch } from 'react-redux'
import { dialogActions } from "../actions/dialog.actions";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ColumnType } from "./PhasePlan/Column";
import { uiActions } from "../actions/ui.actions";
import { LookaheadTag } from '../models/LookaheadTag';

import { getCopiedPhaseTags, getCopiedLookaheadTags } from "../selectors/dialog.selector";
import { lookaheadActions } from "../actions/lookahead.actions";
import { phasePlanActions } from "../actions/phaseplan.actions";

const _ = require("lodash");


interface Props {
    type: ColumnType;
    pasteTags: (isBacklog: boolean, type: ColumnType, isMilestone?: boolean, milestoneTags?: Record<string, LookaheadTag> ) => Promise<void>;
    deselectAfterPastePP: () => Promise<void>;
    deselectAfterPasteMRP: () => Promise<void>;
    columnSelectedAsync: (column: number, row:number, type:ColumnType) => void;
    milestoneTags: Record<string, LookaheadTag>;
    pathName: string,
    showLookaheadTagDialogValue: (tagDate:string, row:number) => void
}


const ColumnContextMenu: React.FC<Props> = ({ columnSelectedAsync, type, pasteTags, milestoneTags, showLookaheadTagDialogValue, deselectAfterPastePP, deselectAfterPasteMRP}) => {


    const handleColumnContextMenuClick = (e:any, data:any, target:any) => {
        const column = target.getAttribute('column')
        const row = target.getAttribute('row')

        switch(data.action) {
            case 'Paste':
                if(type === ColumnType.Lookahead) {

                    batch(() => {
                        columnSelectedAsync(parseInt(column,10), parseInt(row, 10), type)
                        pasteTags(false, type)
                        deselectAfterPasteMRP()
                    })
                   
                }

                if(type === ColumnType.PhasePlan) {

                    batch(() => {
                        columnSelectedAsync(parseInt(column,10), parseInt(row, 10), type)
                        pasteTags(false, type)
                        deselectAfterPastePP()
                    })
                }

                break;
            case 'CreateTag': 
                showLookaheadTagDialogValue(column, row)
                break;
                
        }
    }

    const showCreateTag = () => {
        if(type !== ColumnType.Lookahead) {
            return 
        }

        return (
            <MenuItem data={{ action: 'CreateTag' }} onClick={handleColumnContextMenuClick}>
                Create Tag
            </MenuItem>
        )
    }

    return(
        <React.Fragment>
            <ContextMenu id="column_context_menu">
                <MenuItem data={{ action: 'Paste' }} onClick={handleColumnContextMenuClick}>
                    Paste
                </MenuItem>
                {showCreateTag()}
            </ContextMenu>
        </React.Fragment>
    )
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return {
        pasteTags: (isBacklog: boolean, type:ColumnType) =>
         dispatch(dialogActions.pasteTags(isBacklog, type)),
        deselectAfterPastePP: () => dispatch(phasePlanActions.phasePlanSelectedTagsClearActionAsync()), 
        deselectAfterPasteMRP: () => dispatch(lookaheadActions.lookaheadSelectedTagsClearActionAsync()), 
        columnSelectedAsync: (column: number, row:number, type:ColumnType) => dispatch(uiActions.columnSelectedAsync(column, row, type)),
        showLookaheadTagDialogValue: (tagDate:string, row:number) => dispatch(lookaheadActions.lookaheadDialogOpen(null, null, tagDate, row)),
    }
}

const mapStateToProps = (state:any) => ({
    copiedPhaseTags: getCopiedPhaseTags(state),
    copiedLookaheadTags: getCopiedLookaheadTags(state),
    
})

export default compose<React.ComponentClass>(
    connect(mapStateToProps, mapDispatchToProps),
    
)(ColumnContextMenu)




// WEBPACK FOOTER //
// ./src/components/ColumnContextMenu.tsx